export const INGRESO_ROUTE = '/';
export const MAQUETA_ROUTE = '/maqueta-web';
